<template>
  <div class="CodeQA">
    <!-- 顶部tabs -->
    <div class="header">
      <div class="tabs">
        <div :class="{active:language_type =='all'}" @click="changeLanguageType ('all')">全部</div>
        <div :class="{active:language_type =='c++'}" @click="changeLanguageType ('c++')">C++</div>
        <div :class="{active:language_type =='python3'}" @click="changeLanguageType ('python3')">Python</div>
        <div :class="{active:language_type =='html'}" @click="changeLanguageType ('html')">HTML/JS</div>
        <div :class="{active:language_type =='scratch'}" @click="changeLanguageType ('scratch')">Scratch</div>
      </div>
      <div class="btn">
        <button @click="goCreate()">我要提问</button>
      </div>
    </div>
    <!-- 最新、精华 -->
    <div class="filter">
      <div class="latest " :class="{active:!is_essence}" @click="changeFilter(false)">最新</div>
      <div class="essence" :class="{active:is_essence}" @click="changeFilter(true)">精华</div>
      <span style="font-size:12px; color:#999999;margin-top: 3px;">精华帖将获得5声望奖励,“我们承诺，工作时间内一小时将有人解答”</span>
    </div>
    <!-- list -->
    <div class="postList">
      <ul>
        <!-- 显示精华的时候，不显示置顶 -->
        <template v-if="!is_essence">
          <li v-for="(item,index) in topPost" :key="item.pk" @click="goDetail(item.pk)">
            <div class="left">
              <div class="avatarImage" @click.stop="goUserDetail(item.owner.user_id)">
                <img class="avatarImg" :src="item.owner.avatar" />
                <img class="segmentImg" :src="item.owner.segment.image" />
              </div>
              <div class="name">
                <div class="userName" :title="item.owner.name">{{item.owner.name}}</div>
                <div class="segment">{{item.owner.segment.name}}</div>
              </div>
            </div>
            <div class="center">
              <div class="title">
                <span class="isTop" v-if="item.is_top">置顶</span>
                <span class="isEssence" v-if="item.is_essence">精华</span>
                {{item.title}}
                <span class="tag">{{item.language_type =='unknown'?'未知':item.language_type}}</span>
              </div>
              <div class="times">
                <div class="time">{{item.create_time && item.create_time.split('.')[0].replace(/T/," ")}}</div>
                <div class="first" v-if="item.first_comment_time">
                  <span v-if="item.first_comment_time > 3600">{{Math.floor(item.first_comment_time/3600)}}小时后首评</span>
                  <span v-else-if="item.first_comment_time < 60">首评1分钟</span>
                  <span v-else-if="Math.floor(item.first_comment_time/60)">{{Math.floor(item.first_comment_time/60)}}分钟后首评</span>
                </div>
                <div class="btns" v-if="userInfo.is_staff">
                  <button @click.stop="handleTop(item.pk)">置顶</button>
                  <button @click.stop="handleEssence('top',index,item.pk)">精华</button>
                  <button @click.stop="handleDel('top',index,item.pk)">删除</button>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <img src="@/assets/comment1.png" />
                {{item.comment_count?item.comment_count:'回复'}}
              </div>
              <div @click.stop="likeBtn(item.pk,index,item.is_like,'top')">
                <img src="@/assets/like1.png" v-if="!item.is_like" />
                <img src="@/assets/like2.png" v-else />
                {{item.like_count?item.like_count:'赞'}}
              </div>
              <div @click.stop="flowerBtn(item.pk,index,item.is_flower,'top')">
                <img src="@/assets/flower1.png" v-if="!item.is_flower" />
                <img src="@/assets/flower2.png" v-else />
                {{item.flower_count?item.flower_count:'送花'}}
              </div>
            </div>
          </li>
        </template>

        <li v-for="(item,index) in postList" :key="item.pk" @click="goDetail(item.pk)">
          <div class="left">
            <div class="avatarImage" @click.stop="goUserDetail(item.owner.user_id)">
              <img class="avatarImg" :src="item.owner.avatar" />
              <img class="segmentImg" :src="item.owner.segment.image" />
            </div>
            <div class="name">
              <div class="userName" :title="item.owner.name">{{item.owner.name}}</div>
              <div class="segment">{{item.owner.segment.name}}</div>
            </div>
          </div>
          <div class="center">
            <div class="title">
              <span class="isTop" v-if="item.is_top">置顶</span>
              <span class="isEssence" v-if="item.is_essence">精华</span>
              {{item.title}}
              <span class="tag">{{item.language_type =='unknown'?'未知':item.language_type}}</span>
            </div>
            <div class="times">
              <div class="time">{{item.create_time && item.create_time.split('.')[0].replace(/T/," ")}}</div>
              <div class="first" v-if="item.first_comment_time">
                <span v-if="item.first_comment_time > 3600">{{Math.floor(item.first_comment_time/3600)}}小时后首评</span>
                <span v-else-if="item.first_comment_time < 60">首评1分钟</span>
                <span v-else-if="Math.floor(item.first_comment_time/60)">{{Math.floor(item.first_comment_time/60)}}分钟后首评</span>
              </div>
              <div class="btns" v-if="userInfo.is_staff">
                <button @click.stop="handleTop(item.pk)">置顶</button>
                <button @click.stop="handleEssence('list',index,item.pk)">精华</button>
                <button @click.stop="handleDel('list',index,item.pk)">删除</button>
              </div>
            </div>
          </div>
          <div class="right">
            <div>
              <img src="@/assets/comment1.png" />
              {{item.comment_count?item.comment_count:'回复'}}
            </div>
            <div @click.stop="likeBtn(item.pk,index,item.is_like,'post')">
              <img src="@/assets/like1.png" v-if="!item.is_like" />
              <img src="@/assets/like2.png" v-else />
              {{item.like_count?item.like_count:'赞'}}
            </div>
            <div @click.stop="flowerBtn(item.pk,index,item.is_flower,'post')">
              <img src="@/assets/flower1.png" v-if="!item.is_flower" />
              <img src="@/assets/flower2.png" v-else />
              {{item.flower_count?item.flower_count:'送花'}}
            </div>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>

import { POST, GET, PUT, DELETE } from '@/utils/request'
import { types as LoginTypes } from "@/store/modules/login";
import { mapActions, mapState } from "vuex";
import { SET_VALUE } from '@/utils/index'

export default {
  name: 'CodeQA',
  data () {
    return {
      topPost: '', // 置顶帖子
      postList: [], // 帖子列表
      listPage: 1,//page
      enableNext: true,
      language_type: 'all',
      is_essence: false
    }
  },
  mounted () {
    this.getTopList()
    this.getList()
  },
  methods: {
    ...mapActions({
      setLoadMore: 'setLoadMore',
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
    }),
    // 获取帖子列表
    getList () {
      this.setLoadMore(false)
      let params = {
        types: 'oj',
        page: this.listPage,
        is_top: 'False',
      }
      if (this.language_type != 'all') {
        params.language_type = this.language_type
      }
      if (this.is_essence) {
        params.is_essence = "True"
        delete params.is_top
      }
      GET('/server/community/list_post/', params).then(res => {
        if (this.listPage == 1 && this.language_type == 'all') {
          SET_VALUE("last_oj_post_id", res.results[0].pk)
        }
        this.postList = this.postList.concat(res.results)
        if (res.next) {
          this.enableNext = true
        } else {
          this.enableNext = false
        }
        this.setLoadMore(true)

      })
    },
    handleScroll (e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more_items && that.enableNext) {
          that.listPage++
          that.getList()
        }
      }
    },
    // 获取置顶
    getTopList () {
      this.setLoadMore(false)
      let params = {
        types: 'oj',
        is_top: 'True',
        page_size: 100,
      }
      if (this.language_type != 'all') {
        params.language_type = this.language_type
      }
      GET('/server/community/list_post/', params).then(res => {
        this.topPost = res.results
        this.setLoadMore(true)
      })
    },
    // 修改类型
    changeLanguageType (type) {
      this.language_type = type
      this.postList = []
      this.topPost = []
      this.listPage = 1
      this.getList()
      this.getTopList()
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 获取详情页面的信息
    goDetail (pk) {
      if (location.origin.indexOf('coding61') != -1) {
        window.open('https://oj.coding61.com/postDetail/' + pk + '?from=coding61', '_blank')
      } else {
        window.open('https://app.bcjiaoyu.com:9443/postDetail/' + pk + '?from=coding61', '_blank')
      }
    },
    // 去发帖页面
    goCreate () {
      if (location.origin.indexOf('coding61') != -1) {
        window.open('https://oj.coding61.com/createPost/?from=coding61', '_blank')
      } else {
        window.open('https://app.bcjiaoyu.com:9443/createPost/?from=coding61', '_blank')
      }
    },
    // 点赞按钮
    likeBtn (pk, index, boolean, type) {
      let callback = () => {
        if (boolean) {
          GET(`/server/community/unlike_post/${pk}/`).then(res => {
            if (type === 'top') {
              this.topPost[index].like_count--
              this.topPost[index].is_like = !boolean
            } else {
              this.postList[index].like_count--
              this.postList[index].is_like = !boolean
            }
          })
        } else {
          GET(`/server/community/like_post/${pk}/`).then(res => {
            if (type === 'top') {
              this.topPost[index].like_count++
              this.topPost[index].is_like = !boolean
            } else {
              this.postList[index].like_count++
              this.postList[index].is_like = !boolean
            }
          })
        }
      }
      this.dependLoginStatus().then(callback)
    },
    // 送花按钮
    flowerBtn (id, index, boolean, type) {
      let callback = () => {
        if (boolean) {
          this.$message.info('不可重复送花')
          return
        }
        if (type === 'top') {
          if (this.topPost[index].owner.user === this.username) {
            this.$message.info('不可以给自己送花')
            return
          }
        } else {
          if (this.postList[index].owner.user === this.username) {
            this.$message.info('不可以给自己送花')
            return
          }
        }

        let data = {
          'types': 'post',
          'pk': id
        }
        PUT('/server/community/send_flower/', data).then(res => {
          if (type === 'top') {
            this.topPost[index].flower_count++
            this.topPost[index].is_flower = true
          } else {
            this.postList[index].flower_count++
            this.postList[index].is_flower = true
          }
        })
      }
      this.dependLoginStatus().then(callback)
    },
    // 去往用户详情页面
    goUserDetail (userId) {
      this.$router.push(`/profile/${userId}`);
    },
    // 置顶或者取消置顶
    handleTop (pk) {
      let callback = () => {
        PUT(`/server/community/sticky_post/${pk}/`).then(res => {
          this.changeLanguageType()
        })
      }
      this.dependLoginStatus().then(callback)
    },
    // 加精或者取消加精
    handleEssence (type, index, pk) {
      let callback = () => {
        PUT(`/server/community/essence_post/${pk}/`).then(res => {
          this.$message.success('操作成功')
          if (type == 'list') {
            this.postList[index].is_essence = res.is_essence
          } else {
            this.topPost[index].is_essence = res.is_essence
          }
        })
      }
      this.dependLoginStatus().then(callback)
    },
    // 删除帖子
    handleDel (type, index, pk) {
      let callback = () => {
        DELETE(`/server/community/delete_post/${pk}/`).then(res => {
          this.$message.success('删除成功')
          if (type == 'list') {
            this.$delete(this.postList, index)
          } else {
            this.$delete(this.topPost, index)
          }
        })
      }
      this.dependLoginStatus().then(callback)
    },
    //最新或者精华
    changeFilter (boolean) {
      this.is_essence = boolean
      this.postList = []
      this.listPage = 1
      this.getList()
    }
  },
  computed: {
    ...mapState({
      load_more_items: state => state.community.load_more,
      username: state => state.login.username,
      userInfo: state => state.login.userInfo
    }),
  },
  created () {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>

<style lang="less" scoped>
.CodeQA {
  padding: 10px;
}
// 顶部tabs
.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .tabs {
    display: flex;
    align-items: center;
    line-height: 25px;
    font-size: 15px;
    color: #666666;
    div {
      margin: 0 15px;
      padding: 0 3px;
      cursor: pointer;
    }
    div.active {
      color: #ff7e00;
      border-bottom: 2px solid #ff7e00;
    }
  }
  .btn {
    margin-right: 30px;
    button {
      height: 24px;
      border-radius: 12px;
      color: #fff;
      background: #ff7b00;
      padding: 0 12px;
      cursor: pointer;
      font-size: 14px;
    }
  }
}
// 最新、精华
.filter {
  height: 2rem;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 0.9rem;
  line-height: 0.9rem;
  .active {
    color: #6b45e1;
  }
  .latest {
    padding: 0 0.5rem;
    border-right: 1px solid #999999;
    cursor: pointer;
  }
  .essence {
    padding: 0 0.5rem;
    cursor: pointer;
  }
}
// 列表页面
.postList {
  height: 100%;
  width: 100%;
}
.postList ul {
  li {
    margin-top: 0.5rem;
    background: #f4f3f3;
    padding: 1rem 1.5rem;
    border-radius: 0.25rem;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      width: 8.5rem;
      flex-shrink: 0;
      .avatarImage {
        position: relative;
        margin-right: 0.5rem;
        height: 4rem;
        cursor: pointer;
        .avatarImg {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 1.25rem;
          overflow: hidden;
          position: absolute;
          z-index: 0;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .segmentImg {
          position: relative;
          z-index: 1;
          height: 4rem;
        }
      }
      .name {
        font-size: 0.8rem;
        color: #333;
        width: 4rem;
        .userName {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
        }
        .segment {
          font-size: 0.7rem;
          color: #999999;
          margin-top: 0.3rem;
        }
      }
    }
    .center {
      flex-shrink: 1;
      cursor: pointer;
      width: calc(100% - 21rem);
      .title {
        font-size: 0.8rem;
        color: #6b45e1;
        line-height: 1.5rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        span {
          color: #ffffff;
          height: 1.2rem;
          display: inline-block;
          line-height: 1.2rem;
          padding: 0 0.5rem;
          border-radius: 0.6rem;
        }
        .isTop {
          background: #dd3c53;
        }
        .isEssence {
          background: #ff7b00;
          margin-left: 0.3rem;
        }
        .tag{
          color: #ff7b00;
          font-weight: 500;
          text-transform:capitalize;
        }
      }
      .times {
        display: flex;
        align-items: center;
        margin-top: 0.5rem;
        font-size: 0.7rem;
        .time {
          color: #666666;
        }
        .first {
          color: #666666;
          margin-left: 0.5rem;
        }
        .btns {
          button {
            color: #666666;
            font-size: 0.7rem;
            margin-left: 1.5rem;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      width: 12.5rem;
      div {
        text-align: center;
        margin-left: 2.5rem;
        cursor: pointer;
        img {
          height: 1rem;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>